import { Box, Container, Stack, Typography, Link as MuiLink } from "@mui/material";
import { useTheme } from "@mui/material/styles";

function Footer() {
  const theme = useTheme();

  return (
    <Box
      component="footer"
      sx={{
        mt: 6,
        py: { xs: 3, md: 4 },
        background: `linear-gradient(180deg, ${theme.palette.primary.main} 0%, #000 100%)`,
        color: "#fff"
      }}
    >
      <Container maxWidth="lg">
        <Stack spacing={1} alignItems="center" textAlign="center">
          <Typography
            sx={{
              fontSize: { xs: ".9rem", md: ".95rem" },
              fontWeight: 700,
              color: "#fff"
            }}
          >
            © 2026 SAAC Basketball Quito. All rights reserved.
          </Typography>

          <Typography
            sx={{
              fontSize: { xs: ".85rem", md: ".9rem" },
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              gap: ".35rem",
              color: "#fff"
            }}
          >
            Developed by
            <MuiLink
              href="https://devzone-ec.com"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                fontWeight: 700,
                color: "#fff",
                textDecoration: "none",
                "&:hover": {
                  textDecoration: "underline",
                  opacity: 0.85
                }
              }}
            >
              DEVZONE
            </MuiLink>
            &
            <MuiLink
              href="https://cmsoltec.com"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                fontWeight: 700,
                color: "#fff",
                textDecoration: "none",
                "&:hover": {
                  textDecoration: "underline",
                  opacity: 0.85
                }
              }}
            >
              CMSOLTEC
            </MuiLink>
          </Typography>
        </Stack>
      </Container>
    </Box>
  );
}

export default Footer;